
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiGrid extends Serenity.EntityGrid<UtentiRow, any> {
        protected getColumnsKey() { return UtentiColumns.columnsKey; }
        protected getDialogType() { return UtentiDialog; }
        protected getIdProperty() { return UtentiRow.idProperty; }
        protected getInsertPermission() { return UtentiRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiRow.localTextPrefix; }
        protected getService() { return UtentiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}